import React, { useEffect, useState } from "react";
// import { events } from "../eventsData";
import "../styles/teamEvent.css";
import { Link } from "react-router-dom";
import firebase from "../firebase";

// import web from "../img/web.jpg";
import { motion } from "framer-motion";
// import EventItem from "./EventItem";
// import { useState } from "react";

const Card = ({ id, title, image, currentId, team }) => {
  // console.log(id);
  return (
    <motion.li
      className="card"
      //  style={{ position: "relative" }}
    >
      <motion.div className="event-content-container">
        <motion.div
          className="event-content"
          layoutId={`event-container-${id}`}
        >
          <motion.div
            className="event-image-container"
            layoutId={`event-image-container-${id}`}
          >
            <img className="event-image" src={image} alt="" />
          </motion.div>
          <motion.div
            className="title-container"
            layoutId={`title-container-${id}`}
          >
            <span className="team-name">{team.name}</span>
            <h2 className="title">{title}</h2>
          </motion.div>
        </motion.div>
      </motion.div>
      <Link
        to={`${currentId}/${id}`}
        style={{
          height: "100%",
          width: "100%",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          position: "absolute",
        }}
      ></Link>
    </motion.li>
  );
};

const TeamList = ({ selectedId, currentId }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [teams, setTeams] = useState([]);
  const refEvents = firebase.firestore().collection("events");
  const refTeams = firebase.firestore().collection("teams");
  function getTeams() {
    setLoading(!loading);
    refTeams
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => items.push(doc.data()));
        setTeams(items);
      });
    setLoading(!loading);
  }
  function getEvents(teamID) {
    setLoading(!loading);
    refEvents
      .where("teamID", "==", teamID)
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => items.push(doc.data()));
        setEvents(items);
      });
    setLoading(!loading);
  }
  useEffect(() => {
    getTeams();
    getEvents(selectedId);
  }, []);
  return (
    <motion.ul className="card-list  mt-16">
      {events.map((event) => (
        <Card
          key={event.id}
          id={event.id}
          title={event.name}
          image={event.profileImage}
          currentId={selectedId}
          isSelected={event.id === selectedId}
          team={teams.filter((t) => t.id === event.teamID)}
          description={event.description}
          url={event.url}
        />
      ))}
    </motion.ul>
  );
};
export default TeamList;
